import { useQuery } from '@tanstack/react-query'

import { getAgentReferralCodesOptions } from './agent-referral.options'

export const useGetAgentReferralCodes = () => {
  return useQuery(getAgentReferralCodesOptions())
}
